import { combineReducers } from '@ngrx/store';
import { SharedState } from './shared.state';
import { componentInfoReducer } from './component-info/component-info.reducer';
import { providerReducer } from './provider/provider.reducer';
import { routerReducer } from '@ngrx/router-store';
import { loggedInUserReducer } from './logged-in-user/logged-in-user.reducer';

export const sharedReducer = combineReducers<SharedState>({
  componentInfoState: componentInfoReducer,
  providerState: providerReducer,
  routerState: routerReducer,
  loggedInUserState: loggedInUserReducer,
});
